<script>
import { hour, countdown } from "./format";

export default {
  props: {
    call: {
      type: Object,
      default: null,
    },
    creating: {
      type: Boolean,
      default: false,
    },
    secondsRemaining: {
      type: Number,
      default: 0,
    },
    balance: {
      type: Number,
      default: 0,
    },
    justCreated: {
      type: Boolean,
      default: false,
    },
    redirectIn: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    hour,
    countdown,
  },
};
</script>

<template>
  <div>
    <!-- Sala sendo gerada -->
    <div v-if="creating && !call" class="text-center py-4">
      <b-spinner variant="default" role="status"></b-spinner>
      <p class="text-muted mt-3 mb-0">Gerando sua sala de atendimento, aguarde...</p>
    </div>

    <div v-else-if="call" class="text-center">
      <h5 class="mb-2">{{ justCreated ? "Seu atendimento está pronto" : "Atendimento em andamento" }}</h5>
      <p class="mb-3">
        Disponível até <strong>{{ hour(call.expiration) }}</strong>. Se a chamada cair ou você sair da sala,
        volte aqui e use o mesmo link, <strong>sem nova cobrança</strong>.
      </p>

      <div class="plantao-countdown mb-3">{{ countdown(secondsRemaining) }}</div>

      <button class="btn btn-default btn-block btn-lg" @click="$emit('enter')">
        {{ justCreated ? "Entrar no atendimento" : "Retomar atendimento" }}
      </button>

      <p v-if="justCreated && redirectIn > 0" class="text-muted font-size-13 mt-2 mb-0">
        Redirecionando em {{ redirectIn }}s...
      </p>

      <b-alert v-if="balance >= 1" show variant="light" class="mt-4 mb-0">
        Você possui <strong>{{ balance }}</strong> crédito(s). Um novo atendimento poderá ser solicitado após {{ hour(call.expiration) }}.
      </b-alert>
    </div>
  </div>
</template>

<style scoped>
.plantao-countdown {
  font-size: 2.2rem;
  font-weight: 600;
  letter-spacing: 2px;
  font-variant-numeric: tabular-nums;
}
</style>
